import { MenuDirection } from '../MenuDirection';
import { MenuPosition } from '../MenuPosition';
// default position strategy taken from https://github.com/codastic/react-positioning-portal
// adjusted to work with preferredAutoDirection prop
export var getMenuPosition = function (preferredAutoDirection) {
    return function (parentRect, portalRect) {
        // Open the content portal above the child if there is not enough space to the bottom,
        // but if there also isn't enough space at the top, open to the bottom.
        var openAbove = parentRect.top + parentRect.height + portalRect.height >
            (window.document.documentElement || window.document.body)
                .clientHeight && parentRect.top - portalRect.height > 0;
        var top = openAbove
            ? parentRect.top - portalRect.height + window.scrollY
            : parentRect.top + parentRect.height + window.scrollY;
        var alignRight = true;
        if (preferredAutoDirection !== MenuDirection.Right) {
            // Open the content portal to the left if there is not enough space at the right,
            // but if there also isn't enough space at the right, open to the left.
            alignRight =
                parentRect.left + portalRect.width >
                    (window.document.documentElement || window.document.body)
                        .clientWidth && parentRect.left - portalRect.width > 0;
        }
        var left = !alignRight
            ? parentRect.left + window.scrollX
            : window.scrollX + parentRect.left - portalRect.width + parentRect.width;
        var strategy = MenuPosition.BelowRight;
        if (openAbove && alignRight) {
            strategy = MenuPosition.AboveLeft;
        }
        if (openAbove && !alignRight) {
            strategy = MenuPosition.AboveRight;
        }
        if (!openAbove && alignRight) {
            strategy = MenuPosition.BelowLeft;
        }
        if (!openAbove && !alignRight) {
            strategy = MenuPosition.BelowRight;
        }
        return {
            top: top,
            left: left,
            strategy: strategy
        };
    };
};
//# sourceMappingURL=getMenuPosition.js.map